<label
    *ngIf="(!isCompoundFieldMember) && !(lmColumnLayoutInfo && lmColumnLayoutInfo.isTable && isFormText)"
    soho-label
    [required]="isRequired"
    [attr.for]="id"
    lm-label
    [layoutField] = "field"
    [lmColumnLayoutInfo]="lmColumnLayoutInfo"
    [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
    [layoutInfo]="layoutInfo"
    [personalize]="personalize && !field?.label?.textStyle?.color"
    [isCompoundFieldMember]="isCompoundFieldMember"
    lm-text-style
    [textStyle]="field?.label?.textStyle"
>{{triggerValue| formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
</label>
<ng-container [ngSwitch]="formType">
  <ng-container *ngSwitchCase="formDisplayType.SEARCH_FORM">
    <ng-container *ngIf="isCompoundFieldMember; else NormalField">
      <ng-container [ngSwitch]="displayType">
        <input *ngSwitchCase="layoutDisplayType.PLAIN"
          #Input
            [ngClass]="fieldClassesString"
            [ngStyle]="{'display': showField ? 'inline-block' : 'none'}"
            [attr.aria-label]="triggerValue | formatLabelRule:field:labelResourceValue:model:specFields"
            lm-displayupper [isUpperCase]="isUpperCase"
            lm-field-style [specField]="specField"
            soho-alert
            [attr.id]="id"
            [attr.bindId]="bindId"
            [attr.type]="type"
            [attr.maxlength]="maxLength"
            [attr.size]="size"
            [ngModel]="modelField.value | toDisplayValue:specField:transformOptions"
            (ngModelChange)="onNgModelChange($event)"
            (blur)="onBlur($event)"
        />
        <input *ngSwitchCase="layoutDisplayType.MASK"
          #Input
            [ngClass]="fieldClassesString"
            [ngStyle]="{'display': showField ? 'inline-block' : 'none'}"
            lm-field-style [specField]="specField"
            soho-input [fireInputEventKludge]="false"
            soho-mask [options]="maskOptions"
            soho-alert
            [attr.id]="id"
            [attr.aria-label]="triggerValue | formatLabelRule:field:labelResourceValue:model:specFields"
            [attr.bindId]="bindId"
            [attr.type]="type"
            [attr.size]="size"
            [ngModel]="modelField.value | toDisplayValue:specField:transformOptions"
            (ngModelChange)="onNgModelChange($event)"
            (blur)="onBlur($event)"
        />
        <ng-container *ngIf="isCompoundFieldMember">
          <div *ngIf="isPreviewCompoundMember; then previewMode; else normalMode"></div>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-template #NormalField>
      <ng-container [ngSwitch]="displayType">
        <ng-container *ngSwitchCase="layoutDisplayType.PLAIN">
          <ng-container *ngIf="transformOptions.allowMultiSelections; else single">
            <input
                #Input
                [ngClass]="fieldClassesString"
                [ngStyle]="{'display': showField ? 'inline-block' : 'none'}"
                [attr.id]="id"
                [attr.bindId]="bindId"
                [attr.type]="type"
                [ngModel]="modelField.value | toDisplayValue:specField:transformOptions"
                (ngModelChange)="onNgModelChange($event)"
                soho-alert
                lm-displayupper
                [isUpperCase]="isUpperCase"
                lm-field-style
                [specField]="specField"
                soho-tooltip content="{{modelField.value | toDisplayValue:specField:transformOptions}}"
                soho-field-filter
                [fieldDropdownDataSet]="filterSettings"
                [selectedFilterType]="triggerValue | toFieldOperator : modelField : 'contains'"
                (filtered)="onFiltered($event)"
                (blur)="onBlur($event)"
                (keypress)="onSearchKeypress($event)"
            />
          </ng-container>
          <ng-template #single>
            <input
                #Input
                [ngClass]="fieldClassesString"
                [ngStyle]="{'display': showField ? 'inline-block' : 'none'}"
                [attr.id]="id"
                [attr.bindId]="bindId"
                [attr.type]="type"
                [attr.maxlength]="maxLength"
                [attr.size]="size"
                [ngModel]="modelField.value | toDisplayValue:specField:transformOptions"
                (ngModelChange)="onNgModelChange($event)"
                soho-alert
                lm-displayupper
                [isUpperCase]="isUpperCase"
                lm-field-style
                [specField]="specField"
                soho-tooltip content="{{modelField.value | toDisplayValue:specField:transformOptions}}"
                soho-field-filter
                [fieldDropdownDataSet]="filterSettings"
                [selectedFilterType]="triggerValue | toFieldOperator : modelField : 'contains'"
                (filtered)="onFiltered($event)"
                (blur)="onBlur($event)"
                (keypress)="onSearchKeypress($event)"
            />
          </ng-template>
        </ng-container>
        <ng-container *ngSwitchCase="layoutDisplayType.MASK">
          <ng-container *ngIf="transformOptions.allowMultiSelections; else single">
            <input
                #Input
                [ngClass]="fieldClassesString"
                class="maskedSearchForm"
                [ngStyle]="{'display': showField ? 'inline-block' : 'none'}"
                [attr.id]="id"
                [attr.bindId]="bindId"
                [attr.type]="type"
                [ngModel]="modelField.value | toDisplayValue:specField:transformOptions"
                (ngModelChange)="onNgModelChange($event)"
                soho-alert
                lm-field-style
                [specField]="specField"
                soho-input
                [fireInputEventKludge]="false"
                soho-mask
                [options]="searchFieldMaskOptions"
                soho-tooltip content="{{modelField.value | toDisplayValue:specField:transformOptions}}"
                soho-field-filter
                [fieldDropdownDataSet]="numericFilterSettings"
                [selectedFilterType]="triggerValue | toFieldOperator : modelField"
                (filtered)="onFiltered($event)"
                (blur)="onBlur($event)"
                (keypress)="onSearchKeypress($event)"
            />
          </ng-container>
          <ng-template #single>
            <input
                #Input
                [ngClass]="fieldClassesString"
                [ngStyle]="{'display': showField ? 'inline-block' : 'none'}"
                [attr.id]="id"
                [attr.bindId]="bindId"
                [attr.type]="type"
                [attr.size]="size"
                [ngModel]="modelField.value | toDisplayValue:specField:transformOptions"
                (ngModelChange)="onNgModelChange($event)"
                soho-alert
                lm-field-style
                [specField]="specField"
                soho-input
                [fireInputEventKludge]="false"
                soho-mask
                [options]="maskOptions"
                soho-tooltip content="{{modelField.value | toDisplayValue:specField:transformOptions}}"
                soho-field-filter
                [fieldDropdownDataSet]="numericFilterSettings"
                [selectedFilterType]="triggerValue | toFieldOperator : modelField"
                (filtered)="onFiltered($event)"
                (blur)="onBlur($event)"
                (keypress)="onSearchKeypress($event)"
            />
          </ng-template>
        </ng-container>

        <!-- NOTE: this block is repeated below -->
        <!-- The resource value from message rule processing may have html(rich text). Using soho-editor with innerHTML instead of text node.-->
        <ng-container *ngSwitchCase="layoutDisplayType.PLAIN_FORM_TEXT" [ngSwitch]="hasRichTextVars">
          <!-- Needs to be the same as lm-richtext.component.html displayAsText -->
          <div *ngSwitchCase="true"
              class="editor-container is-preview field">
            <div
                class="lm-richtext-content is-preview hide-white-space"
                [ngClass]="fieldClassesString"
                data-options="{preview: true}"
                [innerHTML]="triggerValue | formatMessageRule:true:field.text:model:specFields"
                [attr.name]="id"
                [attr.id]="id"
                [attr.bindId]="bindId"
                soho-editor
                soho-alert
            ></div>
          </div>
          <ng-container *ngIf="layoutObject.icon">
            <svg *ngIf="validSohoIcon"
                class="icon"
                focusable="false"
                aria-hidden="true"
                role="presentation"
            >
              <use [attr.xlink:href]="'#icon-' +  layoutObject.icon + ''"></use>
            </svg>
            <img *ngIf="!validSohoIcon" class="icon" src="{{iconUrl}}" alt="">
          </ng-container>
          <p *ngSwitchCase="false"
              [attr.id]="id"
              class="lm-form-text hide-white-space"
              [class.personalize-text]="personalize && !layoutObject?.textStyle?.color"
              [class.data]="true"
              lm-text-style
              [textStyle]="layoutObject?.textStyle"
          >{{triggerValue | formatMessageRule:true:field.text:model:specFields}}
          </p>
        </ng-container>
      </ng-container>
    </ng-template>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <div
        [ngClass]="{
          'disabled-member-field': disabledMemberField,
          'lm-is-display-as-tag': displayAsTag,
          'lm-is-display-as-text': displayAsText,
          'lm-is-compact-format': field.type === 'compactFormat'
        }"
        lm-field-options
        [hasContextMenu]="hasContextMenu$ | async"
        [ajaxCallbackFunction]="onBeforeContextMenuOpen"
        [contextMenuEventFunction]="contextMenuClicked"
        [isMemberField]="isCompoundFieldMember"
        [dataEntryMode]="dataEntryMode"
        [buttonId]="fieldOptionsId"
        [fieldOptionsLabel]="fieldOptionsLabel | translate : fieldNameForOptionsMenu"
        [isInAccessibilityMode]="isInAccessibilityMode"
        [displayFieldOptions]="displayFieldOptions"
        [fieldAutomationId]="fieldAutomationId"
        lm-layout-util
        [hideWhiteSpace]="!(lmColumnLayoutInfo && lmColumnLayoutInfo.nbrColumns > 1)"
        soho-tooltip
        [popover]="true"
        [title]="popoverTitle"
        [placement]="'right'"
        [trigger]="'click'"
        (click)="onCompoundFieldClickEvent($event)"
        (focus)="onFocus($event)"
        (blur)="onBlur($event)"
        (contextmenu)="onContextMenu($event)"
        (focusin)="onFieldFocus($event)"
        (focusout)="onFieldBlur($event)">
      <ng-container [ngSwitch]="displayType">
        <input *ngSwitchCase="layoutDisplayType.PLAIN"
          #Input
            [ngClass]="fieldClassesString"
            [class.lm-uppercase]="isUpperCase"
            [ngStyle]="{'display': showField ? 'inline-block' : 'none'}"
            [attr.id]="id"
            [attr.bindId]="bindId"
            [attr.aria-label]="(isCompoundFieldMember) ? (triggerValue| formatLabelRule:field:labelResourceValue:model:specFields) : field?.label?.nolabel && bindId"
            [attr.type]="type"
            [attr.maxlength]="maxLength"
            [attr.size]="size"
            [attr.readOnly]="isReadOnly ? true : null"
            [attr.tabindex]="isInAccessibilityMode ? null : (isReadOnly) ? -1 : null"
            [ngModel]="modelField.value | toDisplayValue:specField:transformOptions"
            (ngModelChange)="onNgModelChange($event)"
            lm-field-style
            [specField]="specField"
            soho-input [fireInputEventKludge]="false"
            soho-alert
            soho-trackdirty
            [searchForm]="onSearchForm"
            (dirty)="onDirty($event)"
            (pristine)="onPristine($event)"
            (afterResetDirty)="onAfterResetDirty($event)"
            soho-input-validate
            (error)="onError($event)"
            (valid)="onValid($event)"
            (blur)="onBlur($event)"
            (input)="onInput($event)"
        />
        <input *ngSwitchCase="layoutDisplayType.MASK"
          #Input
            [ngClass]="fieldClassesString"
            [ngStyle]="{'display': showField ? 'inline-block' : 'none'}"
            [attr.id]="id"
            [attr.bindId]="bindId"
            [attr.aria-label]="(isCompoundFieldMember) ? (triggerValue| formatLabelRule:field:labelResourceValue:model:specFields) : field?.label?.nolabel && bindId"
            [attr.type]="type"
            [attr.size]="size"
            [attr.readOnly]="isReadOnly ? true : null"
            [attr.tabindex]="isInAccessibilityMode ? 0 : (isReadOnly) ? -1 : null"
            [ngModel]="modelField.value | toDisplayValue:specField:transformOptions"
            (ngModelChange)="onNgModelChange($event)"
            lm-field-style
            [specField]="specField"
            soho-input
            [fireInputEventKludge]="false"
            soho-alert
            soho-trackdirty
            [searchForm]="onSearchForm"
            (dirty)="onDirty($event)"
            (pristine)="onPristine($event)"
            (afterResetDirty)="onAfterResetDirty($event)"
            soho-input-validate
            (error)="onError($event)"
            (valid)="onValid($event)"
            soho-mask
            [options]="maskOptions"
            (blur)="onBlur($event)"
            (input)="onInput($event)"
        />

        <!-- NOTE: this block is repeated above -->
        <!-- The resource value from message rule processing may have html(rich text). Using soho-editor with innerHTML instead of text node.-->
        <ng-container *ngSwitchCase="layoutDisplayType.PLAIN_FORM_TEXT" [ngSwitch]="hasRichTextVars">
          <!-- Needs to be the same as lm-richtext.component.html displayAsText -->
          <div *ngSwitchCase="true"
              class="editor-container is-preview field">
            <div
                class="lm-richtext-content is-preview hide-white-space"
                [ngClass]="fieldClassesString"
                [attr.name]="id"
                [attr.id]="id"
                [attr.bindId]="bindId"
                data-options="{preview: true}"
                [innerHTML]="triggerValue | formatMessageRule:true:field.text:model:specFields"
                soho-editor
                soho-alert
            ></div>
          </div>
          <ng-container *ngIf="layoutObject.icon">
            <svg *ngIf="validSohoIcon" class="icon" focusable="false" aria-hidden="true" role="presentation">
              <use [attr.xlink:href]="'#icon-' +  layoutObject.icon + ''"></use>
            </svg>
            <img *ngIf="!validSohoIcon" class="icon" src="{{iconUrl}}" alt="">
          </ng-container>
          <p *ngSwitchCase="false"
              [attr.id]="id"
              class="lm-form-text hide-white-space"
              [class.personalize-text]="personalize && !layoutObject?.textStyle?.color"
              [class.data]="true"
              lm-text-style
              [textStyle]="layoutObject?.textStyle"
          >{{triggerValue | formatMessageRule:true:field.text:model:specFields}}
          </p>
        </ng-container>

        <!-- display as link -->
        <ng-container *ngSwitchCase="layoutDisplayType.HTTP_FORM_TEXT">
          <lm-hyperlink
              [attr.id]="id"
              [specFields]="specFields"
              [model]="model"
              [layoutObject]="layoutObject"
              [layoutInfo]="layoutInfo"
              soho-alert
              (fieldEvent)="onFieldEvent($event)"
          >
          </lm-hyperlink>
        </ng-container>

        <!-- display as tag -->
        <ng-container *ngSwitchCase="layoutDisplayType.DISPLAY_AS_TAG">
          <div
              class="tag-container"
              soho-alert
              lm-field-style
              [fieldStyle]="layoutObject?.fieldStyle"
              [specField]="specField"
          >
            <span
                [attr.id]="id"
                class="tag is-dismissible"
                [class.data]="true"
                [ngClass]="{'is-active': isFieldTagFocused, 'is-focused': isFieldTagFocused, 'hide-focus': !isFieldTagFocused}"
                [ngStyle]="{'color': '#FFFFFF', 'display': 'inline-block', 'outline': 'none'}"
                lm-field-style
                [fieldStyle]="tagStyle?.style"
                [isTag]="true"
                [attr.tabindex]="isInAccessibilityMode ? 0 : null"
                (focus)="onTagFocus()"
                (blur)="onTagBlur()"
            >{{modelField.value | toDisplayValue:specField:transformOptions | formatMessageRule:true:field.text:model:specFields}}</span>
          </div>
        </ng-container>

        <!-- display as text -->
        <ng-container *ngSwitchCase="layoutDisplayType.DISPLAY_AS_TEXT">
          <p
              [attr.id]="id"
              [attr.tabindex]="isInAccessibilityMode ? 0 : null"
              class="lm-text-data hide-white-space"
              [class.personalize-text]="personalize && !layoutObject?.fieldStyle?.color"
              [ngStyle]="{'display': 'inline-block'}"
              [class.data]="true"
              soho-alert
              lm-field-style
              [displayAsText]="true"
              [fieldStyle]="layoutObject?.fieldStyle"
              [specField]="specField"
          >{{modelField.value | toDisplayValue:specField:transformOptions | formatMessageRule:true:field.text:model:specFields}}</p>
        </ng-container>

        <ng-container *ngIf="isCompoundFieldMember">
          <div *ngIf="isPreviewCompoundMember; then previewMode; else normalMode"></div>
        </ng-container>
      </ng-container>
    </div>

    <button *ngIf="field.type === 'compactFormat'"
        id="CompactForm"
        class="lm-compound-field-dialog-button"
        soho-button="btn-icon"
        [icon]="'launch'"
        soho-tooltip
        [content]="launchButtonTooltip"
        (click)="openCompactDialog($event)"
    ></button>
  </ng-container>
</ng-container>

<ng-template #normalMode>
  <span *ngIf="dirtyCompoundField" class="icon-dirty lm-compound-member-field-dirty"></span>
  <ng-container *ngIf="!(modelField.value | isBlankValue:specField); else noValue" >
    <p
        [attr.id]="id + '-text'"
        [attr.aria-label]="triggerValue| formatLabelRule:field:labelResourceValue:model:specFields"
        class="lm-compound-text hide-white-space"
        [attr.tabindex]="(!disabledMemberField) ? tabIndexForFieldOptions : null"
        [ngStyle]="{'display': showField ? 'none' : 'inline-block'}"
        soho-tooltip
        [content]="triggerValue | formatMessageRule:false:labelResourceValue:model:specFields"
        soho-alert
        (focus)="onFocus($event)"
    >{{modelField.value | toDisplayValue:specField:transformOptions | formatMessageRule:true:field.text:model:specFields}}</p>
  </ng-container>
  <ng-template #noValue>
    <p
        [attr.id]="id + '-text'"
        [attr.aria-label]="triggerValue | formatLabelRule:field:labelResourceValue:model:specFields"
        [attr.tabindex]="(!disabledMemberField) ? tabIndexForFieldOptions : null"
        [ngClass]="{'lm-compound-text preview-placeholder': true, 'input-style is-placeholder': !isReadOnly}"
        [ngStyle]="{'display': showField ? 'none' : 'inline-block'}"
        soho-tooltip
        [content]="showLabel ? '' : triggerValue | formatMessageRule:false:labelResourceValue:model:specFields"
        soho-alert
        (focus)="onFocus($event)"
    >{{triggerValue | formatMessageRule:false:labelResourceValue:model:specFields}}</p>
  </ng-template>
</ng-template>
<ng-template #previewMode>
  <ng-container *ngIf="!(modelField.value | isBlankValue:specField); else noValue" >
    <p
        [attr.id]="id + '-text'"
        class="lm-compound-text hide-white-space"
        [attr.aria-label]="triggerValue | formatLabelRule:field:labelResourceValue:model:specFields"
        [ngStyle]="{'display': 'inline-block', 'vertical-align': 'unset'}"
        soho-alert
    >{{modelField.value | toDisplayValue:specField:transformOptions | formatMessageRule:true:field.text:model:specFields}}</p>
  </ng-container>
  <ng-template #noValue>
    <p
        [attr.id]="id + '-text'"
        class="lm-compound-text input-style is-placeholder preview-placeholder"
        [attr.aria-label]="triggerValue | formatLabelRule:field:labelResourceValue:model:specFields"
        [ngStyle]="{'display': showField ? 'none' : 'inline-block'}"
        soho-tooltip
        [content]="showLabel ? '' : triggerValue | formatMessageRule:false:labelResourceValue:model:specFields"
        soho-alert
    >{{triggerValue | formatMessageRule:false:labelResourceValue:model:specFields}}</p>
  </ng-template>
</ng-template>

<ng-template #mouseOverTextTemplate>
  <ng-container *ngIf="layoutObject.mouseOverText">
    <lm-mouse-over-text
        [beforeShowTooltip]="displayMouseOverText"
    ></lm-mouse-over-text>
  </ng-container>
</ng-template>
